import { render } from "./Lifestyle.vue?vue&type=template&id=545c647a&scoped=true"
import script from "./Lifestyle.vue?vue&type=script&lang=js"
export * from "./Lifestyle.vue?vue&type=script&lang=js"

import "./Lifestyle.vue?vue&type=style&index=0&id=545c647a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545c647a"]])

export default __exports__